import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { DailyCheckinStore, DailyCheckinState } from './daily-checkin.store.js';

@Injectable({ providedIn: 'root' })
export class DailyCheckinQuery extends Query<DailyCheckinState> {
  constructor(protected override store: DailyCheckinStore) {
    super(store);
  }
}
